import { Col, Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useThemeComponents } from '../../../../../themes';
import BookingDeposit from '../../../../shared/ThankYou/BookingDeposit';
import DealerInfo from '../../../../shared/ThankYou/DealerInfo';
import SubmittedContent from '../../../../shared/ThankYou/SubmittedContent';
import VehicleDetails from '../../../../shared/ThankYou/VehicleDetails';
import VehicleInfo from '../../../../shared/ThankYou/VehicleInfo';
import VehicleGiftDescription from '../AdyenPaymentPage/VehicleGiftDescription';
import { type GiftVoucherState } from '../reducer';

const colSpan = { lg: 8, md: 12, sm: 24, xs: 24 };

export type GiftVoucherThankYouContentProps = {
    subTitle: string;
    description: string;
    reference: string;
    state: GiftVoucherState;
};
const ThankYouContent = ({ subTitle, description, reference, state }: GiftVoucherThankYouContentProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation(['giftVoucherThankYou']);
    const { Button } = useThemeComponents();

    const { giftVoucher } = state;

    const hasDeposit = !!giftVoucher.deposit;

    return (
        <Row gutter={[24, 24]} justify="center" style={{ marginBottom: '24px' }}>
            <Col {...colSpan}>
                <Space direction="vertical" size={24} style={{ width: '100%' }}>
                    <VehicleDetails
                        vehicleSection={
                            <div>
                                <VehicleInfo state={state} />
                                <VehicleGiftDescription voucher={giftVoucher} />
                            </div>
                        }
                    />
                    {hasDeposit && <BookingDeposit depositAmount={giftVoucher.deposit.amount} />}
                </Space>
            </Col>
            <Col {...colSpan}>
                <Space direction="vertical" size={32} style={{ width: '100%' }}>
                    <SubmittedContent description={description} reference={reference} title={subTitle} />
                    <Space direction="vertical" size={24} style={{ width: '100%' }}>
                        {!!state.giftVoucher.dealer && <DealerInfo dealer={state.giftVoucher.dealer} />}
                        <Button onClick={() => navigate('..')} type="primary" block>
                            {t('giftVoucherThankYou:actions.continueBrowsing')}
                        </Button>
                    </Space>
                </Space>
            </Col>
        </Row>
    );
};

export default ThankYouContent;
